import axiosInstance from './axiosInstance';

export const getWalletRecharges = (params) =>
  axiosInstance.get('/api/v1/admin/wallet/recharges', { params });

export const verifyWalletRecharge = (rechargeId) =>
  axiosInstance.post(`/api/v1/admin/wallet/recharges/${rechargeId}/verify`);

export const getWalletRechargeStats = (days = 30) =>
  axiosInstance.get('/api/v1/admin/wallet/recharges/stats', { params: { days } });
